import { apiGet } from "..";
import { urlObtenerPaises } from "../../constants/urls";

export const obtenerCatalogoPaises = async () => {
    return await apiGet(urlObtenerPaises);
};
